import React, { useState } from "react";
import { fileUrl } from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Film } from "lucide-react";

// ids can be plain file ids or objects {file_id, phase}
export function ImageGallery({ ids, label }) {
  const [active, setActive] = useState(null);
  if (!ids || ids.length === 0) return null;

  const items = ids.map((item) =>
    typeof item === "object" ? { id: item.file_id, phase: item.phase, is_video: item.is_video } : { id: item }
  );

  return (
    <div>
      {label && (
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      )}
      <div className="flex flex-wrap gap-2">
        {items.map((it, i) => (
          <button
            key={i}
            type="button"
            data-testid={`gallery-thumb-${i}`}
            onClick={() => setActive(it)}
            className="group relative h-24 w-24 overflow-hidden rounded-md border border-slate-200 bg-slate-50"
          >
            {it.is_video ? (
              <div className="flex h-full w-full items-center justify-center bg-slate-800">
                <Film className="h-6 w-6 text-white" />
              </div>
            ) : (
              <img
                src={fileUrl(it.id)}
                alt="dokumentasi"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            )}
            {it.phase && (
              <span className="absolute bottom-0 left-0 right-0 bg-black/50 py-0.5 text-center text-[10px] capitalize text-white">
                {it.phase}
              </span>
            )}
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl border-none bg-transparent p-0 shadow-none">
          {active &&
            (active.is_video ? (
              <video
                src={fileUrl(active.id)}
                controls
                autoPlay
                className="max-h-[80vh] w-full rounded-md bg-black"
              />
            ) : (
              <img
                src={fileUrl(active.id)}
                alt="dokumentasi"
                data-testid="lightbox-image"
                className="max-h-[80vh] w-full rounded-md object-contain"
              />
            ))}
        </DialogContent>
      </Dialog>
    </div>
  );
}
